<template lang="pug">
    .manage Manage Forms
</template>
<script>
export default {
  name: 'ManageForms',
};
</script>